export const isMainProductPresentation = (presentation, product) => {
  if (!presentation) {
    return false
  }

  if (
    presentation.is_main ||
    presentation.is_primary ||
    presentation.is_default ||
    presentation.is_principal
  ) {
    return true
  }

  const presentationKey = String(presentation.key || "").trim()
  const productBarCode = String(product?.bar_code || "").trim()
  const presentationUnit = Number(presentation.presentation_unit)

  return presentationUnit === 1 && Boolean(presentationKey) && presentationKey === productBarCode
}
